import { FC } from 'react';
import { Alert } from '@kontentino/ui';
import { useTranslation } from 'react-i18next';

const AnalyticsReportPreviewFailedMessage: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="tw-p-8">
      <Alert variant="danger">
        {t('analyticsReports.publicPreview.failedToBuild.message')}
        <br />
        {t('analyticsReports.publicPreview.failedToBuild.retryMessage')}
      </Alert>
    </div>
  );
};

export default AnalyticsReportPreviewFailedMessage;
